import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css/normalize.css';
import './styles/styles.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/omega/theme.css';
import 'font-awesome/css/font-awesome.css';
import {Provider} from 'react-redux';
import configureStore from './store/configureStore';
import '../node_modules/toastr/build/toastr.min.css';
import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';
import { BrowserRouter  } from 'react-router-dom';
import SdkContainer from './components/SdkContainer';
import smoothscroll from 'smoothscroll-polyfill';
import 'url-search-params-polyfill';
import 'focus-visible';

smoothscroll.polyfill();

/* eslint  import/default: "off" */

const store = configureStore();
ReactDOM.render(
    <Provider store={store}><BrowserRouter><SdkContainer/></BrowserRouter></Provider>, document.getElementById('app'));
